import { Fingerprint } from "lucide-react";

export function BrandMark(): React.JSX.Element {
  return (
    <span className="brand-mark" aria-hidden="true">
      <span className="brand-core"><Fingerprint size={25} strokeWidth={1.8} /></span>
      <i className="brand-node brand-node-a" />
      <i className="brand-node brand-node-b" />
      <i className="brand-node brand-node-c" />
    </span>
  );
}
